import { type Consent } from 'services/api/proxy-consent/data-contracts';
import daysCountdown from 'utils/days-countdown';

import { type MSAConsent } from './consent';

const mapConsentToConsentItem = (consent: Consent | undefined): MSAConsent => {
  if (consent === undefined) {
    return {
      id: '',
      isSigned: false,
      gracePeriodDays: 0,
      expiredGracePeriod: true,
    };
  }

  const shouldBeSignedUntil = consent.shouldBeSignedUntil ? new Date(consent.shouldBeSignedUntil) : new Date();
  const gracePeriodDays = daysCountdown(shouldBeSignedUntil.getTime());

  return {
    id: consent.id,
    isSigned: Boolean(consent.isSigned),
    gracePeriodDays,
    expiredGracePeriod: !consent.isSigned && gracePeriodDays < 1,
  };
};

export { mapConsentToConsentItem };
